// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"style_descriptions__3vDtC"};